import "antd/dist/reset.css";
import "./index.css";

import { useMount, useUnmount } from "ahooks";
import { ConfigProvider } from "antd";
import { Locale } from "antd/es/locale";
import enUS from "antd/lib/locale/en_US";
import esES from "antd/lib/locale/es_ES";
import zhCN from "antd/lib/locale/zh_CN";
import zhTW from "antd/lib/locale/zh_TW";
import i18next from "i18next";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { RecoilRoot } from "recoil";

import AppLayout from "./components/layout/layout";
import { Env } from "./config/env";
import { TOKEN_IN_COOKIE } from "./libs/constants";
import * as models from "./models";
import { login as loginRoute } from "./routes/login";
import {
  IAtomInitState,
  setupStoreageState,
  withInitializeState,
} from "./utils/recoil-utils";
import { localSet } from "./utils/storage";
/**
 * 应用入口
 */
function App() {
  const [initState, setInitState] = useState<IAtomInitState[] | undefined>(
    undefined
  );

  const { pathname } = useLocation();

  const getLocaleLang = (lang: string): Locale => {
    switch (lang) {
      case "zhCN":
        return zhCN;
      case "zhTW":
        return zhTW;
      case "en":
        return enUS;
      case "esES":
        return esES;
      default:
        return zhCN;
    }
  };

  const [lang, setLang] = useState<Locale>(getLocaleLang(i18next.language));

  const handleSetToken = (token: string) => {
    Cookies.set(TOKEN_IN_COOKIE, `Bearer ${token}`, {
      domain: Env.DOMAIN,
    });
  };

  useEffect(() => {
    setupStoreageState(models)
      .then(setInitState)
      .catch(() => null);
    const handleLangChange = (val: string) => {
      setLang(getLocaleLang(val));
    };

    i18next.on("languageChanged", handleLangChange);

    return () => {
      i18next.off("languageChanged", handleLangChange);
    };
  }, []);

  // 监听路由变化，记录参数
  useEffect(() => {
    if (!loginRoute.some((item) => item.path === pathname)) {
      localSet("search", window.location.search);
    }
  }, [pathname]);

  useMount(() => {
    (window as any).$wujie?.bus.$on("send_token", handleSetToken);
  });

  useUnmount(() => {
    (window as any).$wujie?.bus.$off("send_token", handleSetToken);
  });
  // setInterval(() => {
  //   handleRefreshToken();
  // }, 100 * 1000);

  if (!initState) return null;

  return (
    <ConfigProvider
      locale={lang}
      theme={{ token: { colorPrimary: "#475aec" } }}
    >
      <RecoilRoot initializeState={withInitializeState(initState)}>
        <AppLayout />
      </RecoilRoot>
    </ConfigProvider>
  );
}

export default App;
